import React, { useState, useEffect } from "react";
import { Button, Input, Modal, Popconfirm, Select, Table, Tooltip, notification } from "antd";
import { useNavigate } from "react-router-dom";
import {
  CheckCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeFilled,
  EyeOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { SuccessToast } from "../../../widgets/AppToast";
import { formatDateTime } from "../../../utils/dateFormatter";
const { Option } = Select;

const ListShip = () => {
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [showAudit, setShowAudit] = useState(false);
  const [buttonName, setButtonName] = useState("Audit Trail");
  const [auditTrailData, setAuditTrailData] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [changesData, setChangesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ship_id, set_ship_id] = useState("");
  const [number_of_duplicates, set_number_of_duplicates] = useState("");

  const LIST_APIS = () => {
    set_loader(true);
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          // setFilteredData(res?.ships);
          setFilteredData(res?.ships);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
      set_loader(false);
    } finally {
    }
  };

  const GET_AUDIT_TRAIL_API = () => {
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.company_ship_audit_trail, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setAuditTrailData(res?.audit_logs);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const onDeleteShip = (ship_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", ship_id);
    post(ApiURL.delete_ship, FORM_DATA).then((res) => {
      if (res?.status == true) {
        notification.open({
          message: "Success!!",
          description: "Ship Details Successfully deleted.",
          icon: <SmileOutlined style={{ color: "green" }} />,
        });
        LIST_APIS();
      } else {
        notification.open({
          description: "Ship delete Error",
          icon: <SmileOutlined style={{ color: "red" }} />,
        });
      }
    });
  };

  const onChangeStatus = (ship_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", ship_id);
    post(ApiURL.ship_status, FORM_DATA).then((res) => {
      if (res?.status == true) {
        notification.open({
          message: "Success!!",
          description: `Ship status Successfully changed to ${res?.shipstatus}.`,
          icon: <SmileOutlined style={{ color: "green" }} />,
        });
        LIST_APIS();
      }
    });
  };

  const handleViewChanges = (record) => {
    const formattedChanges = Object.entries(record.changes).map(([key, value]) => ({
      field: key,
      oldValue: value[0],
      newValue: value[1],
    }));
    setChangesData(formattedChanges);
    setIsModalVisible(true);
  };

  useEffect(() => {
    LIST_APIS();
  }, []);

  useEffect(() => {
    GET_AUDIT_TRAIL_API();
  }, [buttonName]);

  function Duplicate_ship() {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      FORM_DATA.append("number_of_duplicates", number_of_duplicates);
      post(ApiURL.duplicate_ship_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success Message", res?.message);
          LIST_APIS();
        }
      });
    } catch (error) {
      console.log("Error in Duplicate Ship", error);
    }
  }

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Ship Name ",
      dataIndex: "vessel_name",
      align: "center",
      key: "vessel_name",
    },
    {
      title: "Flag ",
      dataIndex: "flag",
      align: "center",
      key: "flag",
    },
    {
      title: "IMO Number",
      dataIndex: "imo_number",
      align: "center",
      key: "imo_number",
    },
    {
      title: "Status",
      dataIndex: "shipstatus",
      align: "center",
      key: "shipstatus",
      render: (text, record) => {
        if (record?.status) {
          return <span className="table-status-activate">Active</span>;
        } else {
          return <span className="table-status-deactivate">Inactive</span>;
        }
      },
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            <Popconfirm
              title="Change Status"
              description={`Do you want to change the status of ${record.vessel_name}?`}
              onConfirm={() => onChangeStatus(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Change Status">
                <Button
                  type="primary"
                  size="small"
                  style={{ marginRight: "15px" }}
                  icon={<CheckCircleOutlined />}
                />
              </Tooltip>
            </Popconfirm>
            <Tooltip title="Edit Ship">
              <Button
                type="primary"
                size="small"
                onClick={() => navigate(`/edit-ship/${btoa(record.id)}`)}
                style={{ marginRight: "15px" }}
                icon={<EditOutlined />}
              />
            </Tooltip>
            <Tooltip title="Duplicate this ship">
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setIsModalOpen(true);
                  set_ship_id(record.id);
                }}
                style={{ marginRight: "15px" }}
                icon={<CopyOutlined />}
              />
            </Tooltip>

            <Popconfirm
              title="Delete Ship"
              description={`Are you sure you want to delete the ship "${record.vessel_name}"?`}
              onConfirm={() => onDeleteShip(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Ship">
                <Button type="primary" size="small" icon={<DeleteOutlined />} />
              </Tooltip>
            </Popconfirm>
          </>
        );
      },
    },
  ];

  // this refers to audit trail
  const columns1 = [
    {
      title: "Id",
      dataIndex: "object_id",
      key: "object_id",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (action) => (action == 1 ? "update" : "create"),
      align: "center",
    },

    {
      title: "Vessel Name",
      dataIndex: "vessel_name",
      key: "vessel_name",
      align: "center",
    },
    {
      title: "Created by",
      dataIndex: "user_name",
      key: "user_name",
      align: "center",
    },
    {
      title: "Updated by",
      dataIndex: "update_user_name",
      key: "update_user_name",
      align: "center",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Updated Date & Time",
      dataIndex: "timestamp",
      key: "timestamp",
      align: "center",
      render: (text, record) => formatDateTime(record?.timestamp),
    },
    {
      title: "Changes",
      dataIndex: "button",
      key: "Origin",
      align: "center",
      render: (_, record) => (
        // <Button
        //   type="primary"
        //   size="small"
        //   onClick={() => handleViewChanges(record)}
        //   style={{ marginRight: "15px" }}
        //   icon={<EyeOutlined />}
        // ></Button>
                        <Tooltip
  title="View"
  placement="right"
  getPopupContainer={() => document.body}
  autoAdjustOverflow={false}
>
  <Button
    type="primary"
    size="small"
    onClick={() => handleViewChanges(record)}
    style={{ marginRight: "5px" }}
    icon={<EyeFilled />}
  />
</Tooltip>
      ),
    },
  ];

  // this colum refer to changes
  const columns2 = [
    {
      title: "Field Name",
      dataIndex: "field",
      key: "field",
      align: "center",
    },
    {
      title: "Old Value",
      dataIndex: "oldValue",
      key: "oldValue",
      align: "center",
    },
    {
      title: "Updated Value",
      dataIndex: "newValue",
      key: "newValue",
      align: "center",
    },
  ];

  const handleButtonClick = () => {
    setButtonName((prev) => (prev === "Audit Trail" ? "Ship List" : "Audit Trail"));
    setShowAudit((prev) => !prev);
  };

  return (
    <>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>{buttonName === "Audit Trail" ? "Ship List" : "Audit Trail"}</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              onClick={() => {
                if (!showAudit) {
                  navigate("/add-ship");
                }
                setShowAudit(false);
                setButtonName((prev) => (prev === "Ship List" ? "Audit Trail" : "Ship List"));
              }}
              className="save_btn"
              type="primary"
              style={{ marginRight: "10px" }}
            >
              Add Ships
            </Button>
            <Button onClick={handleButtonClick} className="save_btn" type="primary">
              {buttonName}
            </Button>
          </div>
        </div>
      </div>
      {!showAudit && (
        <Table
          bordered
          columns={columns}
          dataSource={FilteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={loader}
          className="custom-table"
        />
      )}
      {showAudit && (
        <Table
          bordered
          columns={columns1}
          dataSource={auditTrailData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={loader}
          className="custom-table"
        />
      )}

      <Modal
        title="Change History"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="close"
            onClick={() => setIsModalVisible(false)}
            style={{ background: "#E11236", color: "white" }}
          >
            Close
          </Button>,
        ]}
        width={"70%"}
        bodyStyle={{
          maxHeight: "60vh",
          overflowY: "auto",
        }}
        centered
      >
        <Table
          columns={columns2}
          dataSource={changesData}
          pagination={false}
          rowKey="field"
          className="custom-table"
          scroll={{ y: 400 }}
        />
      </Modal>
      <Modal
        title="Duplicate Ship"
        open={isModalOpen}
        onOk={Duplicate_ship}
        onCancel={() => setIsModalOpen(false)}
        okText="Submit"
      >
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Ship ID</label>
            <Input
              disabled
              type="text"
              placeholder="Ship ID"
              value={ship_id}
              // onChange={(e) => set_ship_id(e.target.value)}
            />
          </div>
        </div>
        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <label>Number of Duplicates</label>
            <Select
              placeholder="Select Number of Duplicates"
              value={number_of_duplicates}
              onChange={(value) => set_number_of_duplicates(value)}
              style={{ width: "100%" }}
            >
              {[...Array(10)].map((_, index) => (
                <Option key={index + 1} value={(index + 1).toString()}>
                  {index + 1}
                </Option>
              ))}
            </Select>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListShip;
